import _ from "lodash";
import React, { useCallback, useEffect, useMemo } from "react";
import { Button } from "reactstrap";
import {
  OPENAI_GET_LOADING,
  OPENAI_SYNC_LOADING,
} from "../../../../constants/loading.constant";
import { OPENAI_SIDE_MODAL_RIGHT } from "../../../../constants/modal.constant";
import { useGlobalCore } from "../../../../cores/globals";
import { useMeCore } from "../../../../cores/me";
import {
  SocialProviderId,
  SocialProviderName,
} from "../../../../cores/socialPost/config";
import { useIntl } from "react-intl";
import { SocialProvider } from "../../../../cores/socialPost/interfaces/socialProvider";
import SocialCard from "../SocialCard";
import { useOpenAiCore } from "../../../../cores/openAi";
import { OpenAiIcon } from "./OpenAiIcon";
import OpenAiToken from "./OpenAiToken";

export default function OpenAiAuthButton() {
  const intl = useIntl();
  const { get, settings, unbind } = useOpenAiCore();
  const { company, getMeSocialSettings } = useMeCore();
  const { turnOnModal, isLoading } = useGlobalCore();

  useEffect(() => {
    get(company!.id);
  }, [company, get]);

  const socialProvider = useMemo(
    (): SocialProvider => ({
      id: SocialProviderId.OpenAi,
      name: SocialProviderName.OpenAi,
      icon: <OpenAiIcon size="5x" active={!_.isEmpty(settings)} />,
      displayName: settings?.name,
    }),
    [settings]
  );

  const isActive = useMemo((): boolean => !_.isEmpty(settings), [settings]);
  const isManaged = useMemo(
    (): boolean => Boolean(settings?.managed),
    [settings]
  );

  const handleBind = useCallback(async () => {
    turnOnModal(OPENAI_SIDE_MODAL_RIGHT, <OpenAiToken />);
  }, [turnOnModal]);

  const handleUnbind = useCallback(() => {
    unbind(company!.id, () => {
      getMeSocialSettings(company?.id!);
    });
  }, [company, unbind, getMeSocialSettings]);

  return (
    <Button
      className="w-100 mx-auto"
      color="primary"
      outline={isActive && !isManaged}
      onClick={isActive && !isManaged ? handleUnbind : handleBind}
    >
      {isActive && !isManaged
        ? intl.formatMessage({ id: "app.home.disconnect" })
        : intl.formatMessage({ id: "app.home.syncUp" })}
    </Button>
  );
}
